import InfoLayout from "./InfoLayout";

function Support() {
    return (
        <InfoLayout title="Kontakt / Support">
            <div>
                <p><strong>Email:</strong> <a href="mailto:admin@tabataworkout.online">admin@tabataworkout.online</a></p>
                <p><strong>Provozovatel:</strong> <a href="https://www.tabataworkout.online" target="_blank" rel="noopener noreferrer">www.tabataworkout.online</a></p>
                
                <hr />

                <p>Máte nápad, jak aplikaci Tabata časovač vylepšit? Chybí vám nějaká funkce, kterou byste rádi viděli? Nebo jste narazili na bug či jinou chybu?  
Rádi uslyšíme vaše postřehy a návrhy – každá zpětná vazba nám pomáhá udělat aplikaci lepší a uživatelsky přívětivější. Neváhejte nás kontaktovat!</p>

            </div>
        </InfoLayout>
    );
}

export default Support;
